<template>
  <div class="sm:col-span-6">
    <label class="block text-sm font-medium">
      {{ $t('Upload files') }}
    </label>
    <div
      v-bc-uploader="{
        name: 'StorageExplorerUploadDropZone',
        onFileUploadDone: bcStorageExplorerStore.fileUploadDone,
        onUploadStart: bcStorageExplorerStore.uploadStart,
        onUploadStop: bcStorageExplorerStore.uploadStop,
        onAllFilesUploadDone: allFilesUploadDone,
        click: false,
        highlightTimeout: 50
      }"
      class="UploadDropZoneParent"
      ref="uploaderEl"
    >
      <div
        @click="$refs.uploaderEl.awVueUploader.fileInput.click()"
        class="DataUpload__UploadDropZone w-full flex justify-center items-center px-6 py-2 mt-1 border-1 border-dashed rounded-md cursor-pointer border-gray-400 hover:border-bc-blue text-gray-400 hover:text-bc-blue"
      >
        <div class="space-x-1 text-center">
          <svg
            class="inline-block h-6 w-6"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 48 48"
            aria-hidden="true"
          >
            <path
              d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="relative cursor-pointer rounded-md">
            {{ $t('Drag the file here, or click to add a file') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import useBcStorageExplorerStore from '@/frontapp/store/bcStorageExplorer'

export default {
  props: {
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapStores(useBcStorageExplorerStore),
  },
  methods: {
    allFilesUploadDone(files, uploaderId) {
      this.bcStorageExplorerStore.show = false
      return this.bcStorageExplorerStore.allFilesUploadDone(files, uploaderId)
    },
  }
}
</script>

<style lang="scss" scoped>
.DataUpload__UploadDropZone {
  min-height: 6.75rem;
}
</style>
